// The small uppercase "eyebrow" pill repeated near-identically at the top of every
// page (Home, Product Overview, Delay Cost Calculator, About).
export default function Badge({ children }) {
  return <span className="badge">{children}</span>;
}
